
import Base from "../base/Base.vue";
export default class EnterPin extends Base {
  Pin = "";

  joinGame() {
    const { displayName, email } = this.currentUser as any;
    const link = `${this.baseUrl}/player/?pin=${this.Pin}&name=${displayName}&email=${email.replace(
      "@",
      "%40"
    )}&avatar=${this.currentUser.photoURL}`;
    if (this.Pin) {
      window.open(link);
    }
  }
}
